export default "__VITE_ASSET__MLlLhRZa__"